import { render, staticRenderFns } from "./FormProjectUpload.vue?vue&type=template&id=45d59c35&"
import script from "./FormProjectUpload.vue?vue&type=script&lang=js&"
export * from "./FormProjectUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports